//import _ from 'lodash';
import { connect } from 'react-redux';
import { clearError, clearSuccess, clearSaving } from '../modules/general';
import { logout, stopViewAs } from '../modules/auth';
import { bindActionCreators } from 'redux';

// XXX memoize
const mapStateToProps = state => {
	return {
		errorMessages : state.general.errorMessages,
		savingMessage: state.general.savingMessage,
		successMessages : state.general.successMessages,
		onSuccessRedirectTo : state.general.onSuccessRedirectTo,
		authUser : state.auth.authUser,
		impersonation : state.auth.impersonation,
		savingStatus: state.general.savingStatus,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	logout,
	stopViewAs,
	clearError,
	clearSuccess,
	clearSaving,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
